import PropTypes from "prop-types";
import {PRIORITY_COLOR} from "../data/data.jsx";

export function TaskData(props) {
    const {title, isHtml, data, priority} = props;
    return (
        isHtml ? <div dangerouslySetInnerHTML={{__html: data}}></div> : <p><span style={{
            fontSize: 'large', fontWeight: 'bold', color: "black"
        }}>{title} </span>{data.toString()}</p>
    )
}

TaskData.propTypes = {
    title: PropTypes.string, data: PropTypes.string, priority: PropTypes.number
}

